<script lang="ts">
  import type { Snippet } from 'svelte'
  import { setContext } from 'svelte'
  import { writable } from 'svelte/store'
  import type { HTMLAttributes } from 'svelte/elements'

  type Props = HTMLAttributes<HTMLDivElement> & {
    children: Snippet
    defaultValue: string
  }

  const { children, defaultValue, ...rest }: Props = $props()

  const selected = writable<string | undefined>(undefined)

  setContext('tabs', {
    selected,
  })

  $effect(() => {
    selected.set(defaultValue)
  })
</script>

<div {...rest}>
  {@render children()}
</div>
